import { render, staticRenderFns } from "./editHousekeepingServ.vue?vue&type=template&id=20d2bbb6&scoped=true"
import script from "./editHousekeepingServ.vue?vue&type=script&lang=js"
export * from "./editHousekeepingServ.vue?vue&type=script&lang=js"
import style0 from "./editHousekeepingServ.vue?vue&type=style&index=0&id=20d2bbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2bbb6",
  null
  
)

export default component.exports